import React from 'react';

import { Treatment } from '../../../../types/treatment';
import FormsDisplayLayout from '../../FormsDisplayLayout/FormsDisplayLayout';
import { title, DISABLED_FIELDS } from '../UnpaidBillForm';

const UnpaidBillDisplay = ({ treatment }: { treatment: Treatment }) => {
  return <FormsDisplayLayout treatment={treatment} disabledFields={DISABLED_FIELDS} />;
};

export default UnpaidBillDisplay;

export const UnpaidBillDisplayOption = {
  title: title,
  Component: UnpaidBillDisplay,
};
